export function unixtime(date: Date, digit?: number) {
  const today = date ? +date : +new Date();
  return today.toString().length === (digit ?? 10)
    ? today
    : Math.trunc(today / 1000);
}
